( function ( $ ) {
	'use strict';

	const $html = $( 'html' );

	$( '.hub-navigation__toggle-mobile' ).on( 'click', function () {
		$html.toggleClass( 'subnav-open' );
	} );

	$( '.hub-navigation__search-toggle' ).on( 'click', function () {
		$( '.hub-navigation' ).toggleClass( 'search-open' );
	} );



} )( jQuery );
